var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#af0800",
    d: "M5 1h1M5 2h1M4 3h1m1 0h1m1 0h1M4 4h1m1 0h1m1 0h1M4 5h1m2 0h1m1 0h1M3 6h1m5 0h1M2 7h1m6 0h1M2 8h1m6 0h1M2 9h1m2 0h2m2 0h1m-7 1h2m2 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f21c00",
    d: "M5 3h1m0 2h1m1 0h1M4 6h1m2 0h2M3 7h1m4 0h1M3 8h1m4 0h1M3 9h2m2 0h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4c00",
    d: "M5 4h1M5 5h1m0 1h1M4 7h1m2 0h1M4 8h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8300",
    d: "M5 6h1M5 7h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire4A);
export default __webpack_public_path__ + "static/media/fire4a.614cb9890a33bc184fb8a9d66b5a6930.svg";
export { ForwardRef as ReactComponent };